<!--
 * @Author: awu
 * @Date: 2020-11-11 20:38:29
 * @LastEditors: awu
 * @LastEditTime: 2020-11-15 11:58:25
 * @Description: file content
-->
<template>
    <div id="app">
        <!-- <keep-alive>
            <router-view></router-view>
        </keep-alive> -->
        <router-view></router-view>
         <!-- iframe页 -->
        <component
            v-for="item in hasOpenComponentsArr"
            :key="item.name"
            :is="item.name"
            v-show="$route.path === item.path"
        ></component>
    </div>
</template>

<script>
import Vue from "vue";

export default {
    name: "App",
    provide(){
        return{
        reload:this.reload
        }
    },
    data(){
        return {
            loading:true,
            isRouterAlive:true,
            componentsArr: []
        }
    },
    watch: {
        $route() {
            // 判断当前路由是否iframe页
            this.isOpenIframePage();
        }
    },
    created() {
        // 设置iframe页的数组对象
        const componentsArr = this.getComponentsArr();
        componentsArr.forEach((item) => {
            Vue.component(item.name, item.component);
        });
        this.componentsArr = componentsArr;
        // 判断当前路由是否iframe页
        this.isOpenIframePage();
    },
    computed: {
        // 实现懒加载，只渲染已经打开过（hasOpen:true）的iframe页
        hasOpenComponentsArr() {
            return this.componentsArr.filter(item => item.hasOpen);
        }
    },
    // mounted() {
    //     if (this.isMobile()) {
    //         alert("手机端");
    //         this.$router.replace('/mobileExhibition');
    //     } else {
    //         alert("pc端");
    //         this.$router.replace('/exhibition');
    //     }
    // },
    methods:{
        // 根据当前路由设置hasOpen
        isOpenIframePage() {
            const target = this.componentsArr.find(item => {
                return item.path === this.$route.path
            });
            if (target && !target.hasOpen) {
                target.hasOpen = true;
            }
        },
        // 遍历路由的所有页面，把含有iframeComponent标识的收集起来
        getComponentsArr() {
            const router = this.$router;
            const routes = router.options.routes;
            const iframeArr = routes.filter(item => item.iframeComponent);
            
            return iframeArr.map((item) => {
                const name = item.name || item.path.replace('/', '');
                return {
                    name: name,
                    path: item.path,
                    hasOpen: false, // 是否打开过，默认false
                    component: item.iframeComponent // 组件文件的引用 
                };
            });
        }
        // isMobile() {
        //     let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        //     return flag;
        // }
    }
};
</script>
<style>
    html,body,#app{
        height: 100%;
    }
    .big{
        width: 100%;
        height: 100%;
        background: rgba(red, green, blue, alpha);
        position: absolute;
        top: 0;
        left: 0;
    }
    .loading{
        width: 100%;
        height: 100%;
    }
    /*全局滚动条样式*/
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: rgb(211, 211, 211);
    }
    /*全局滚动条样式结束*/
</style>



// WEBPACK FOOTER //
// src/App.vue